import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';
const ManageNotifications = lazy(
  () => import('../communication/notifications/ManageNotifications')
);

const CommunicationMain = lazy(
  () => import('../communication/CommunicationMain')
);

const NotificationSubscriptions = lazy(
  () => import('../communication/notifications/NotificationsSubscriptions')
);

const ManageSubscriptions = lazy(
  () => import('../communication/notifications/ManageSubscriptions')
);

const CustomNotifications = lazy(
  () => import('../communication/notifications/CustomNotifications')
);

export default [
  {
    id: NavConfig.groupConfigs.COMMUNICATION.id,
    path: NavConfig.groupConfigs.COMMUNICATION.to,
    element: (
      <CommunicationMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </CommunicationMain>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.COMM_PLAYER_MEMO.to} />,
      },
      {
        id: NavConfig.linkConfigs.COMM_MANAGE_NOTIFICATIONS.id,
        path: NavConfig.linkConfigs.COMM_MANAGE_NOTIFICATIONS.to,
        element: <ManageNotifications />,
      },
      {
        id: NavConfig.linkConfigs.COMM_NOTIFICATION_SUBS.id,
        path: NavConfig.linkConfigs.COMM_NOTIFICATION_SUBS.to,
        element: <ManageSubscriptions />,
      },
      {
        id: NavConfig.linkConfigs.COMM_CUSTOM_NOTIFICATION.id,
        path: NavConfig.linkConfigs.COMM_CUSTOM_NOTIFICATION.to,
        element: <CustomNotifications />,
      },
    ],
  },
  {
    id: NavConfig.linkConfigs.MANAGE_MY_NOTIFICATIONS.id,
    path: NavConfig.linkConfigs.MANAGE_MY_NOTIFICATIONS.to,
    element: <NotificationSubscriptions />,
  },
];
